<template>
    <section>
        <el-tabs v-model="activeName" type="card">
            <el-tab-pane label="User List" name="first">
                <el-col :span="24" class="toolbar" style="padding-bottom: 0px;">
                    <el-form :inline="true" :model="filters">
                        <el-form-item>
                            <el-input v-model="filters.email" placeholder="Email" clearable>
                                <el-button slot="append" icon="el-icon-search" @click="getUserList"></el-button>
                            </el-input>
                        </el-form-item>
                    </el-form>
                </el-col>

                <!--列表-->
                <el-table stripe :data="users" highlight-current-row v-loading="firstListLoading" style="width: 100%;">
                    <el-table-column prop="userName" label="User Name">
                    </el-table-column>
                    <el-table-column prop="email" label="Email">
                    </el-table-column>
                    <el-table-column label="Date Time" :formatter="formatTimesTamp">
                    </el-table-column>
                    <el-table-column prop="statusName" label="Status">
                    </el-table-column>
                    <el-table-column label="Action">
                        <template slot-scope="scope">
                            <el-button size="small" type="danger" v-if="scope.row.statusName==='Enabled'"
                                       @click="editUserStatus(scope.row.userNo,2)">Disable
                            </el-button>
                            <el-button size="small" type="primary" v-if="scope.row.statusName==='Disabled'"
                                       @click="editUserStatus(scope.row.userNo,1)">Enable
                            </el-button>
                        </template>
                    </el-table-column>
                </el-table>

                <!--工具条-->
                <el-col :span="24" class="toolbar">
                    <el-pagination layout="prev, pager, next" @current-change="handleUserPageChange"
                                   :page-size="pageSize"
                                   :total="total" style="float:right;">
                    </el-pagination>
                </el-col>
            </el-tab-pane>

            <el-tab-pane label="Invitation List" name="second">
                <el-col :span="24" class="toolbar" style="padding-bottom: 0px;">
                    <el-form :inline="true" :model="filters">
                        <el-form-item>
                            <el-input v-model="filters.invitationEmail" placeholder="Email" clearable>
                                <el-button slot="append" icon="el-icon-search" @click="getInvitationList"></el-button>
                            </el-input>
                        </el-form-item>
                        <el-form-item class="pull-right">
                            <el-button type="primary" v-on:click="invitationVisible=true">Invitation</el-button>
                        </el-form-item>
                    </el-form>
                </el-col>

                <!--列表-->
                <el-table stripe :data="invitations" highlight-current-row v-loading="secondListLoading" style="width: 100%;">
                    <el-table-column prop="email" label="Email">
                    </el-table-column>
                    <el-table-column prop="createDate" label="Date Time" :formatter="formatTimesTamp">
                    </el-table-column>
                    <el-table-column prop="statusName" label="Status" :formatter="formatRole">
                    </el-table-column>
                </el-table>

                <!--工具条-->
                <el-col :span="24" class="toolbar">
                    <el-pagination layout="prev, pager, next" @current-change="handleInvitationPageChange"
                                   :page-size="pageSize"
                                   :total="invitationTotal" style="float:right;">
                    </el-pagination>
                </el-col>
            </el-tab-pane>
        </el-tabs>

        <el-dialog title="Invite Doctor" width="80%" :visible.sync="invitationVisible" :close-on-click-modal="false">
            <el-form :model="invitation" label-width="220px" :rules="invitationRules" ref="invitation">
                <el-form-item label="Email" prop="email">
                    <el-input type="email" v-model="invitation.email"></el-input>
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click.native="invitationVisible = false">Close</el-button>
                <el-button type="primary" @click.native="invitationRegister" :loading="loading">Submit</el-button>
            </div>
        </el-dialog>

    </section>
</template>


<script>
    import util from '../../common/js/util'
    import {invitationRegister, editUserStatus, getAllMemberList,getAdminInvitationList,invitationDoctor} from '../../api/memberService';
    import {defaultPageSize} from "../../globalVar";
    import ElButton from "element-ui/packages/button/src/button";

    export default {
        components: {ElButton},
        data() {
            return {
                loading: false,
                firstListLoading: false,
                secondListLoading: false,
                pageSize: defaultPageSize,

                activeName: "first",

                filters: {
                    email: '',
                    invitationEmail:""
                },


                users: [],
                invitations:[],

                total: 0,
                userPage: 1,

                invitationPage:1,
                invitationTotal:0,

                invitationVisible: false,

                editLoading: false,

                addLoading: false,
                invitationRules: {
                    email: [
                        {required: true, message: 'Email is required.', trigger: 'blur'},
                        {validator: util.validateEmail, trigger: 'blur'}
                    ]
                },
                //新增界面数据
                member: {
                    id: "",
                    userName: "",
                    email: "",
                    phone: "",
                    status: "",
                    pendingTransaction: 7,
                    pendingAmount: "",
                    alias: ""
                },
                group: {
                    id: '',
                    groupName: "",
                    users: [],
                    pendingTransaction: 7,
                    pendingAmount: ""
                },
                invitation: {
                    id: "",
                    email: ""
                }

            }
        },
        methods: {
            formatRole(row, column) {
                if (row.status === 0) {
                    return "Pending";
                } else if (row.status === 1) {
                    return "Approve";
                } else {
                    return "Reject"
                }
            },
            formatTimesTamp(row, column) {
                let date = row.createTime||row.createDate;
                return util.formatDate.format(new Date(date), 'yyyy-MM-dd hh:mm:ss');
            },
            handleUserPageChange(val) {
                this.userPage = val;
                this.getUserList();
            },
            handleInvitationPageChange(val) {
                this.invitationPage = val;
                this.getInvitationList();
            },
            editUserStatus(id, status) {
                this.$confirm("Are you sure?", "Warning", {
                    type: "warning"
                }).then(() => {
                    editUserStatus({userNo: id, status: status}).then((res) => {
                        if (res.status === 200) {
                            this.$message({
                                message: res.message,
                                type: "success"
                            });
                            this.getUserList();
                        } else {
                            this.$message({
                                message: res.message,
                                type: "error"
                            })
                        }
                    })
                }).catch(() => {

                })

            },
            getUserList() {
                let para = {
                    current: this.userPage,
                    size: this.pageSize,
                    condition: this.filters.email
                };

                this.firstListLoading = true;
                getAllMemberList(para).then(res => {
                    this.firstListLoading = false;
                    if (res.status === 200) {
                        this.users = res.result.records;
                        this.total = res.result.total;
                    } else {
                        this.$message({
                            message: res.message,
                            type: 'error'
                        })
                    }
                })
            },
            getInvitationList(){
                let para = {
                    current: this.invitationPage,
                    size: this.pageSize,
                    condition: this.filters.invitationEmail
                };

                this.secondListLoading = true;
                getAdminInvitationList(para).then(res => {
                    this.secondListLoading = false;
                    if (res.status === 200) {
                        this.invitations = res.result.records;
                        this.invitationTotal = res.result.total;
                    } else {
                        this.$message({
                            message: res.message,
                            type: 'error'
                        })
                    }
                })
            },
            invitationRegister(param) {
                this.$refs.invitation.validate((valid) => {
                    if (valid) {
                        invitationDoctor({email: this.invitation.email}).then(res => {
                            if (res.status === 200) {
                                this.$message({
                                    message: 'Success',
                                    type: 'success'
                                });
                                this.invitationVisible = false;
                                this.getInvitationList();
                                this.$refs.invitation.resetFields();
                            } else {
                                this.$message({
                                    message: res.message,
                                    type: 'error'
                                });
                            }
                        }).catch(error => console.log(error))
                    }
                });
            }
        },
        mounted() {
            this.getUserList();
            this.getInvitationList();
        }
    }

</script>


// WEBPACK FOOTER //
// userlist.vue?6c4073a9